export { HotelOverviewComponent, HotelOverviewComponentEditable } from './HotelOverview';
